<template>
  <div>
    <NavigationBar titel="Veranstaltungen" :actions="actions"></NavigationBar>
    <section>
      <TippCard hintID="SCHEDULING_EVENTS_1_V2">
        <template v-slot:content>
          <p class="body-2">
            Bevorstehende Veranstaltungen werden hier zusammen mit den
            wichtigsten Informationen angezeigt. Deine Rückmeldung kannst du
            direkt hier über den Button und in den Veranstaltungsdetails
            abgeben.
            <br /><br />
            Drei verschiedene Ansichten geben einen Überblick über die
            notwendigen Daten: Die eigene Rückmeldung kann über die
            <v-icon dense>mdi-view-agenda-outline</v-icon> komplexe Ansicht
            bereits bearbeitet werden. In der
            <v-icon dense>mdi-view-sequential-outline</v-icon> kompakten Ansicht
            werden nur wichtigen Daten zur Veranstaltung angezeigt. Die
            <v-icon dense>mdi-table</v-icon> Tabelle listet die Veranstaltungen
            mit Sortierfunktionen auf.
          </p>

          <p class="body-2">
            Folgende Icons und Farben kennzeichnen deine Rückmeldung
            übersichtlich:
          </p>
          <div>
            <v-chip
              label
              small
              color="green lighten-4"
              class="mr-1 mt-1 green--text text--darken-4"
            >
              <v-icon small>mdi-check-circle</v-icon>
              <span class="ml-1 font-weight-bold">Verfügbar</span>
            </v-chip>

            <v-chip
              label
              small
              color="orange lighten-4"
              class="mr-1 mt-1 orange--text text--darken-4"
            >
              <v-icon small>mdi-minus-circle</v-icon>
              <span class="ml-1 font-weight-bold">Wenn notwendig</span>
            </v-chip>

            <v-chip
              label
              small
              color="red lighten-4"
              class="mr-1 mt-1 red--text text--darken-4"
            >
              <v-icon small>mdi-close-circle</v-icon>
              <span class="ml-1 font-weight-bold">Nicht verfügbar</span>
            </v-chip>

            <v-chip
              label
              small
              color="blue lighten-4"
              class="mr-1 mt-1 blue--text text--darken-4"
            >
              <v-icon small>mdi-airplane</v-icon>
              <span class="ml-1 font-weight-bold">Nicht in Stadt</span>
            </v-chip>

            <v-chip
              label
              small
              color="blue-grey lighten-4"
              class="mr-1 mt-1 blue-grey--text text--darken-4"
            >
              <v-icon small>mdi-help-circle</v-icon>
              <span class="ml-1 font-weight-bold">Keine Rückmeldung</span>
            </v-chip>

            <v-chip
              label
              small
              color="purple lighten-4"
              class="mr-1 mt-1 purple--text text--darken-4"
            >
              <v-icon small>mdi-cancel</v-icon>
              <span class="ml-1 font-weight-bold"
                >Veranstaltung teilnahmebeschränkt</span
              >
            </v-chip>
          </div>
        </template>
      </TippCard>
      <TippCard
        titel="Teilnahme von Veranstaltungen absagen"
        text="Musst Du deine Teilnahme an einer Veranstaltung aus wichtigem Grund
            absagen, hast aber bereits eine positive Rückmeldung abgegeben und
            die Rückmeldefrist ist abgelaufen? Die Teilnahme lässt sich für
            diese Veranstaltungen über Mira One direkt absagen. Festgelegte
            Personen und Organisatoren der Veranstaltung werden benachrichtigt
            und die eigene Rückmeldung angepasst."
        hintID="NEW_SCHEDULING_EVENTS_CANCELLATION_NOTICE_V1"
      >
      </TippCard>
      <TippCard
        titel="Mit Kalenderfeeds Termine synchronisieren"
        hintID="NEW_CALENDAR_FEEDS_V1"
      >
        <template v-slot:content>
          <p class="body-2">
            Egal ob iCal, Outlook oder Google Calendar: Mit einem persönlichen
            Kalenderfeed werden Veranstaltungen über einen Link direkt mit
            Deiner Kalender-App synchronisiert.
          </p>
          <v-btn
            depressed
            class="mt-2"
            :to="{ name: 'scheduling-calendar-feeds' }"
            >Persönlichen Kalenderfeed anfordern<v-icon right
              >mdi-chevron-right</v-icon
            ></v-btn
          >
        </template>
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-calendar-account"
                title="Bevorstehende Veranstaltungen"
              >
                <template v-if="!$vuetify.breakpoint.mdAndUp" v-slot:title>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          $store.state.organization.activeOrganization.config
                            .scheduling.showAllEventsInList ||
                          checkIfSupport ||
                          checkIfItService
                        "
                        :color="$vuetify.theme.dark ? '' : 'white'"
                        v-bind="attrs"
                        v-on="on"
                        class="hidden-md-and-up"
                        outlined
                        :class="[
                          'v-btn-toggle',
                          $vuetify.theme.dark
                            ? ''
                            : 'grey--text text--darken-1',
                        ]"
                        style="
                          border-color: rgba(0, 0, 0, 0.12) !important;
                          border-width: 1px !important;
                        "
                      >
                        <span>
                          <v-icon left small>mdi-calendar-filter</v-icon>
                          {{ eventsFilter }}
                        </span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list nav>
                      <v-list-item-group v-model="eventsFilter" mandatory>
                        <v-list-item link dense value="Alle">
                          <v-list-item-icon>
                            <v-icon dense>mdi-all-inclusive</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Alle Veranstaltungen anzeigen</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item link dense value="Eigene">
                          <v-list-item-icon>
                            <v-icon dense>mdi-filter</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Nur eigene Veranstaltungen</v-list-item-title
                          >
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:actions>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          $store.state.organization.activeOrganization.config
                            .scheduling.showAllEventsInList ||
                          checkIfSupport ||
                          checkIfItService
                        "
                        outlined
                        :color="$vuetify.theme.dark ? '' : 'white'"
                        v-bind="attrs"
                        v-on="on"
                        :class="[
                          'mr-4',
                          'hidden-sm-and-down',
                          'v-btn-toggle',
                          $vuetify.theme.dark
                            ? ''
                            : 'grey--text text--darken-1',
                        ]"
                        style="
                          border-color: rgba(0, 0, 0, 0.12) !important;
                          border-width: 1px !important;
                        "
                      >
                        <span>
                          <v-icon left small>mdi-calendar-filter</v-icon>
                          {{ eventsFilter }}
                        </span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list nav>
                      <v-list-item-group v-model="eventsFilter" mandatory>
                        <v-list-item link dense value="Alle">
                          <v-list-item-icon>
                            <v-icon dense>mdi-all-inclusive</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Alle Veranstaltungen anzeigen</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item link dense value="Eigene">
                          <v-list-item-icon>
                            <v-icon dense>mdi-filter</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Nur eigene Veranstaltungen</v-list-item-title
                          >
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                  <v-btn-toggle dense v-model="helpers.displayMode" mandatory>
                    <v-btn outlined icon value="detailed-list">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-view-agenda-outline</v-icon
                      >
                    </v-btn>
                    <v-btn outlined icon value="list">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-view-sequential-outline</v-icon
                      >
                    </v-btn>
                    <v-btn depressed outlined icon value="table">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-table</v-icon
                      >
                    </v-btn>
                  </v-btn-toggle>
                </template>
              </Subheader>
              <div
                v-if="
                  helpers.displayMode === 'detailed-list' ||
                  helpers.displayMode === 'list'
                "
                class="mt-4"
              >
                <v-skeleton-loader
                  v-if="helpers.dataIsLoading"
                  elevation="2"
                  type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
                ></v-skeleton-loader>
                <events-list
                  :events="
                    schedulingConfigShowAllEventsInList &&
                    eventsFilter === 'Alle'
                      ? allEvents
                      : onlyOwnEvents
                  "
                  :displayMode="helpers.displayMode"
                  :userGroupId="$store.state.organization.membership.group.id"
                  :userUid="currentUserUid"
                  :userDivisionId="
                    $store.state.organization.membership.user.division.id
                  "
                >
                </events-list>
              </div>
              <div v-else class="mt-4">
                <v-skeleton-loader
                  v-if="helpers.dataIsLoading"
                  elevation="2"
                  type="table"
                ></v-skeleton-loader>
                <events-data-table
                  :events="
                    schedulingConfigShowAllEventsInList &&
                    eventsFilter === 'Alle'
                      ? allEvents
                      : onlyOwnEvents
                  "
                ></events-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import { SCHEDULING } from "@/store/modules.js";
import {
  GET_EVENTS,
  // CREATE_EVENT_CANCELLATION_NOTICE,
} from "@/store/action-types.js";
import { SCHEDULING_EVENTS_create } from "@/data/permission-types.js";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import EventsDataTable from "@/components/scheduling/EventsDataTable.vue";
import EventsList from "@/components/scheduling/EventsList.vue";

export default {
  name: "scheduling-events",
  components: {
    NavigationBar,
    Subheader,
    SupportTools,
    TippCard,
    EventsDataTable,
    EventsList,
  },
  data() {
    return {
      eventsFilter: "Eigene",

      currentUserUid: auth.currentUser.uid,
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          actionStyle: "textBtnMultiple",
          permission: `${SCHEDULING_EVENTS_create}`,
          list: [
            {
              title: "Veranstaltung erstellen",
              icon: "mdi-plus-circle",
              function: () => {
                this.$router.push({ name: "scheduling-event-new" });
              },
              permission: `${SCHEDULING_EVENTS_create}`,
            },
            {
              title: "Veranstaltung mit Vorlage erstellen",
              icon: "mdi-book-arrow-right",
              function: () => {
                this.$router.push({
                  name: "scheduling-event-new",
                  query: { fromTemplate: true },
                });
              },
              permission: `${SCHEDULING_EVENTS_create}`,
            },
            {
              title: "Mehrere Veranstaltungen erstellen",
              icon: "mdi-plus-circle-multiple",
              function: () => {
                this.$router.push({ name: "scheduling-event-new-multi" });
              },
              permission: `${SCHEDULING_EVENTS_create}`,
            },
            {
              title: "Veranstaltungen mittels CSV-Import erstellen",
              icon: "mdi-database-import",
              disabled: true,
              // function: this.createFromCSV,
              permission: `${SCHEDULING_EVENTS_create}`,
            },
          ],
        },
      ],
      helpers: {
        dataIsLoading: true,
        displayMode: "detailed-list",
        formIsValid: false,
        isLoading: false,
      },
    };
  },
  computed: {
    code() {
      return [
        { title: "events", data: this.events },
        { title: "eventsStatus", data: this.eventsStatus },
        { title: "allEvents", data: this.allEvents },
        { title: "schedulingConfig", data: this.schedulingConfig },
      ];
    },
    checkFeatureAvability() {
      return this.$store.getters["organization/checkFeatureAvailabilityById"](
        "showEventResponsesCount",
      );
    },
    organizationAllowsCancellationNotice() {
      return this.$store.state.organization.activeOrganization.config.scheduling
        .cancellation.allowNotice;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    checkIfItService() {
      return this.$store.getters["organization/checkIfItService"];
    },
    schedulingConfig() {
      return this.$store.state.organization.activeOrganization.config
        .scheduling;
    },
    schedulingConfigShowAllEventsInList() {
      return this.$store.state.organization.activeOrganization.config.scheduling
        .showAllEventsInList;
    },
    events() {
      return this.$store.state.scheduling.events;
    },
    eventsStatus() {
      return this.$store.state.scheduling.eventsStatus;
    },
    allEvents() {
      return this.events.map((event) => {
        const userResponse = this.eventsStatus.find(
          (userResponse) => userResponse.userResponse.eventId === event.meta.id,
        );

        if (
          userResponse &&
          userResponse.userResponse.status.id === "0" &&
          !this.userIsInvited(event)
        ) {
          userResponse.userResponse.status.id = "-0";
        }

        return {
          ...event,
          ...userResponse,
          deadlineIsExpired: this.deadlineIsExpired(event),
        };
      });
    },
    onlyOwnEvents() {
      const userGroupId = this.$store.state.organization.membership.group.id;
      const divisionId =
        this.$store.state.organization.membership.user.division.id;
      return this.allEvents.filter((event) => {
        const { allowedAttendeesIds, isLimited } = event.config.attendance;
        return (
          !isLimited ||
          allowedAttendeesIds.includes("all") ||
          allowedAttendeesIds.includes(auth.currentUser.uid) ||
          allowedAttendeesIds.includes(userGroupId) ||
          allowedAttendeesIds.includes(divisionId)
        );
      });
    },
  },
  created() {
    this.initialize();
    if (this.events.length > 0) {
      this.helpers.dataIsLoading = false;
    }
  },
  methods: {
    initialize() {
      return this.getEvents().then(
        () => {
          this.helpers.dataIsLoading = false;
        },
        (error) => {
          console.error(error);
        },
      );
    },
    getEvents() {
      return this.$store.dispatch(`${SCHEDULING}${GET_EVENTS}`, {
        organizationId: this.$route.params.organizationId,
        withStatus: true,
        query: {
          onlyOwn: false,
        },
      });
    },
    userIsInvited(event) {
      if (!event.config.attendance.isLimited) {
        return true;
      }

      const userGroupId = this.$store.state.organization.membership.group.id;
      const divisionId =
        this.$store.state.organization.membership.user.division.id;
      const allowedAttendees = event.config.attendance.allowedAttendeesIds;

      return (
        allowedAttendees.includes("all") ||
        allowedAttendees.includes(auth.currentUser.uid) ||
        allowedAttendees.includes(userGroupId) ||
        allowedAttendees.includes(divisionId)
      );
    },
    deadlineIsExpired(event) {
      const deadline = this.getDeadline(event, false);
      const now = new Date();

      return now.getTime() > deadline.getTime();
    },
    getDeadline(event, withFormat) {
      const deadline = event.config.responses.deadline;
      if (deadline.isCustom) {
        // custom deadline
        if (withFormat) {
          return this.timestampConverter(deadline.timestamp);
        } else {
          return deadline.timestamp.toDate();
        }
      } else {
        // global deadline

        var durationInMin = this.schedulingConfig.defaultDeadlineInMinutes;
        //var durationInMin = 60;
        var MS_PER_MINUTE = 60000;
        var enddate = event.duration.start.firebaseFormat.toDate();
        var calc = new Date(enddate - durationInMin * MS_PER_MINUTE);

        // V2: also working
        // var startdate = new Date(enddate);
        // const output = new Date(startdate.setUTCMinutes(enddate.getUTCMinutes() - durationInMin));

        if (withFormat) {
          // return this.timestampConverter(calc);
          const options = {
            weekday: "short",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          };
          return calc.toLocaleDateString("de-DE", options);
        } else {
          return calc;
        }
      }
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
